<template>
  <Popup :alt="true" v-model="show" :closable="false">
    <div class="thanks">
      <div class="thanks__title thanks__title_absolute" :class="{ 'active': sendedWithComment }">
        Спасибо! Ваш&nbsp;отзыв&nbsp;учтен!
        <br>
        <a @click="thanksclick" class="thanks__title-link" :href="returnlink">Вернуться на сайт</a>
      </div>
      <div class="thanks__title" :class="{ 'active': !sendedWithComment }">
        Спасибо!<br>
        Ваши данные успешно отправлены
      </div>
      <div class="thanks__wrapper" :class="{ 'active': sendedWithComment }" ref="wrapper">
        <div class="thanks__subtitle">Как вам процесс оформления?</div>
        <div class="thanks__buttons">
          <div role="button" aria-label="Approve" class="thanks__button thanks__button_approve" :class="{ 'active': rated == 1 }" @click="approve">
            <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="0.5" width="56" height="56" rx="28" />
              <path d="M25.2146 36.8125L33.5669 36.8125C34.3371 36.8125 34.996 36.3485 35.2745 35.6916L38.0725 29.2144C38.156 29.0031 38.207 28.778 38.207 28.5437L38.207 26.7843L38.1978 26.7752L38.207 26.7063C38.207 25.691 37.3764 24.8688 36.351 24.8688L30.4905 24.8687L31.3767 20.6701C31.3953 20.5782 31.4092 20.4817 31.4092 20.3807C31.4092 19.9994 31.2514 19.6548 31.0009 19.4068L30.0125 18.4375L23.9014 24.4875C23.5674 24.8228 23.3585 25.2822 23.3585 25.7875L23.3585 34.975C23.3585 35.9902 24.1891 36.8125 25.2146 36.8125ZM21.5025 36.8125L21.5025 25.7875L17.7904 25.7875L17.7904 36.8125L21.5025 36.8125Z" fill="white" />
            </svg>
          </div>
          <div role="button" aria-label="Disapprove" class="thanks__button thanks__button_disapprove" :class="{ 'active': rated == -1 }" @click="disapprove">
            <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="0.5" width="56" height="56" rx="28" />
              <path d="M25.2146 20.1875L33.5669 20.1875C34.3371 20.1875 34.996 20.6515 35.2745 21.3084L38.0725 27.7856C38.156 27.9969 38.207 28.222 38.207 28.4563L38.207 30.2157L38.1978 30.2248L38.207 30.2937C38.207 31.309 37.3764 32.1312 36.351 32.1312L30.4905 32.1313L31.3767 36.3299C31.3953 36.4218 31.4092 36.5183 31.4092 36.6193C31.4092 37.0006 31.2514 37.3452 31.0009 37.5932L30.0125 38.5625L23.9014 32.5125C23.5674 32.1772 23.3585 31.7178 23.3585 31.2125L23.3585 22.025C23.3585 21.0098 24.1891 20.1875 25.2146 20.1875ZM21.5025 20.1875L21.5025 31.2125L17.7904 31.2125L17.7904 20.1875L21.5025 20.1875Z" fill="white" />
            </svg>
          </div>
        </div>
        <Transition name="fadeheight">
          <div class="thanks__commentblock" v-if="rated">
            <div class="thanks__commenttitle">Напишите здесь Ваши замечания и предложения</div>
            <textarea v-model="comment" class="thanks__area" />
            <button class="thanks__btn" @click="sendComment">Отправить</button>
          </div>
        </Transition>
      </div>
    </div>
  </Popup>
</template>

<script>
import { mapState } from 'vuex';
import Popup from './Popup.vue';
export default {
  data: () => ({
    sessionId: undefined,
    rated: false,
    sendedWithComment: false,
    comment: '',
    timer: undefined
  }),
  components: { Popup },
  computed: {
    ...mapState(['thanksShow', 'returnlink']), //id === ordernumber
    show: {
      get() {
        return this.thanksShow
      },
      set(v) {
        this.$store.commit('setThanksShow', v)
      }
    }
  },
  watch: {
    thanksShow() {
      clearTimeout(this.timer)
    }
  },
  methods: {
    thanksclick() {
      if (!this.returnlink)
        this.$store.commit('setThanksShow', false)

    },
    hideContent() {
      let content = this.$refs.wrapper
      content.style.setProperty('height', getComputedStyle(content).height)
      window.requestAnimationFrame(() => {
        content.style.setProperty('height', '0px')
      })
    },
    approve() {
      this.rated = 1
      this.notifyServer()
    },
    disapprove() {
      this.rated = -1
      this.notifyServer()
    },
    sendComment() {
      this.notifyServer()
    },
    async notifyServer() {
      try {
        if (!this.rated) return console.error('Не указана оценка')
        if (this.rated != 1 && this.rated != -1) return console.error('Ошибка. Неверная оценка')
        this.sendData()
      } catch (err) {
        console.log('Error: ' + err)
      }
    },
    async sendData() {
      let data = { 'rezult': this.rated == 1 ? 'yes' : 'no', 'url': window.location.href }
      if (this.comment) {
        data.comment = this.comment
        this.sendedWithComment = true
        this.hideContent()
      }
      if (this.sessionId)
        data.id = this.sessionId

      await fetch(`https://rosbankinsurance.ru/bitapi/quality/control/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'no-cors',
        body: JSON.stringify(data)
      })
        .then(async res => {
          if (!res.ok) throw res.status
          return res.json()
        })
        .then(obj => this.sessionId = obj.id)
        .catch(err => console.log(err))
    }
  }
}
</script>

<style lang="sass">
.fadeheight-enter-active,.fadeheight-leave-active 
  transition: .5s ease
  max-height: 264px
  opacity: 1

.fadeheight-enter-from,.fadeheight-leave-to
  opacity: 0
  max-height: 0px

.thanks
  letter-spacing: globalvars.$onespacing
  &__wrapper
    transition: .5s ease
    opacity: 1
    &.active
      opacity: 0
      overflow: hidden
  &__title
    padding-top: 3px
    font-weight: 500
    font-size: 24px
    line-height: 1.16
    text-align: center
    color: colors.$bluefont
    margin-bottom: 48px
    transition: opacity .5s ease
    opacity: 0
    &-link
      font-size: 20px
      display: block
      margin: 25px auto 0
      color: colors.$newred
      text-decoration: underline
      text-underline-offset: 2px
      font-weight: 500
    &.active
      opacity: 1
    &_absolute
      position: absolute
      width: 100%
      left: 0
      padding: 0 32px
  &__subtitle
    font-size: 20px
    line-height: 118%
    text-align: center
    color: colors.$gray5
    margin-bottom: 32px
  &__buttons
    display: flex
    justify-content: center
    margin-bottom: 16px
    >*:not(:last-child)
      margin-right: 32px
  &__commentblock
    margin-bottom: 16px
  &__button
    cursor: pointer
    &_approve 
      svg rect
        fill: #8DC3F4
      &:hover svg rect 
        fill: darken(saturate(#8DC3F4, 35), 20)
      &:active svg rect, &.active svg rect
        fill: darken(saturate(#8DC3F4, 95), 20)
    &_disapprove 
      svg rect
        fill: #FC8D8D
      &:hover svg rect 
        fill: darken(saturate(#FC8D8D, 35), 20)
      &:active svg rect, &.active svg rect
        fill: colors.$newred
  &__commenttitle
    font-size: 14px
    line-height: 1.12
    padding: 16px 0
    color: colors.$gray5
  &__area
    height: 128px
    width: 100%
    padding: 19px 16px
    resize: none
    border: none
    font-size: 16px
    line-height: 1.12
    color: colors.$newgray
    margin-bottom: 26px
    border-bottom: 1px solid #DEE3EE
    outline: none
    transition: .3s ease-out
    &:focus-visible
      border-bottom-color: colors.$newgray
  &__btn
    cursor: pointer
    width: 327px
    height: 56px
    max-width: 100%
    display: flex
    align-items: center
    justify-content: center
    text-align: center
    margin: 0 auto
    padding-bottom: 0
    padding-top: 3px
    transition: .3s ease-out
    box-shadow: 0px 24px 24px rgba(242, 40, 87, 0.16)
    border-radius: 8px
    font-weight: 500
    font-size: 18px
    line-height: 136%    
    letter-spacing: globalvars.$onespacing
    color: colors.$notred
    background: colors.$newred
    @include for-mob
      width: 100%
    &_center
      position: fixed
      z-index: 99
      left: 50%
      margin: 0
      transform: translateX(-50%)
      bottom: 32px
      @include for-mob
        width: calc(100% - 32px)
        margin: 0
    img
      width: 40px
      transform-origin: center center
      display: block
      animation: rotating 2s linear infinite
    &:hover, &:focus-visible
      &:not(.popup__next_loading)
        background: colors.$newRedHover
    &:disabled
      background: colors.$moar_silver_for_the_god_of_silver2
      box-shadow: 0px 24px 24px rgba(210, 212, 218, 0.16)      
    &:disabled, &_loading
      pointer-events: none  
</style>